import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { Label, SelectBaseOptionReg, SelectPropsReg, SelectReg } from '@britishcouncil/react-registration-platform';

import { CustomerMinor } from '@/store/webApi';

type Props = {
  minors?: CustomerMinor[];
  onMinorChange: (id: string) => void;
  defaultMinorId?: string;
};

export const ChooseMinor = ({ minors = [], onMinorChange, defaultMinorId }: Props) => {
  const { t } = useTranslation('');

  const options = useMemo(() => {
    const addNew = {
      value: 'new',
      label: t('minor-details.choose-minor.add-new'),
    };

    const opts = minors.map((minor) => ({
      value: minor.customerId ?? -1,
      label: [minor.firstName, minor.lastName].filter(Boolean).join(' '),
    }));

    return [...(opts ?? []), addNew];
  }, [minors, t]);

  const onChange: Pick<SelectPropsReg<SelectBaseOptionReg>, 'onChange'>['onChange'] = (option) => {
    if (option && 'value' in option) {
      onMinorChange(String(option.value));
    }
  };

  const defaultMinorValue = useMemo(
    () => options.find(option => option.value === defaultMinorId),
    [options, defaultMinorId]
  );

  if (!minors.length) {
    return null;
  }

  return (
    <div>
      <Label placeholder="">{t('minor-details.choose-minor.label')}</Label>
      <SelectReg
        defaultValue={defaultMinorValue}
        options={options}
        placeholder={t('minor-details.choose-minor.placeholder')}
        onChange={onChange}
      />
    </div>
  );
};
